import { render, staticRenderFns } from "./FormDos.vue?vue&type=template&id=58d27082&scoped=true&"
import script from "./FormDos.vue?vue&type=script&lang=js&"
export * from "./FormDos.vue?vue&type=script&lang=js&"
import style0 from "./FormDos.vue?vue&type=style&index=0&id=58d27082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d27082",
  null
  
)

export default component.exports